import React, { useEffect } from 'react';
import { Modal, Form, Input, InputNumber, Button, Space, message } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';

/**
 * 自定义售卖 - 功能入口 新增/编辑弹窗
 * 功能入口 = 企业自定义的售卖位置（名称 + code + 排序）
 */
const EntryFormDialog = ({ open, editData, existingCodes = [], onCancel, onSubmit }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (open) {
            if (editData) {
                form.setFieldsValue({ name: editData.name, code: editData.code, sort: editData.sort });
            } else {
                form.resetFields();
                form.setFieldsValue({ sort: 1 });
            }
        }
    }, [open, editData, form]);

    const handleOk = async () => {
        const values = await form.validateFields();
        const code = (values.code || '').trim();
        const duplicated = existingCodes.some((c) => c.code === code && c.id !== editData?.id);
        if (duplicated) {
            message.error(`功能入口编码「${code}」已存在，请使用其他编码`);
            return;
        }
        onSubmit({ ...values, code });
        form.resetFields();
    };

    return (
        <Modal
            title={editData ? '编辑功能入口' : '新增功能入口'}
            open={open}
            onCancel={onCancel}
            width={480}
            destroyOnClose
            footer={(
                <Space>
                    <Button icon={<CloseOutlined />} onClick={onCancel}>取消</Button>
                    <Button type="primary" icon={<CheckOutlined />} onClick={handleOk}>保存</Button>
                </Space>
            )}
        >
            <Form form={form} layout="vertical">
                <Form.Item
                    label="功能入口名称"
                    name="name"
                    rules={[{ required: true, message: '请输入功能入口名称' }, { max: 30, message: '名称长度在 1 到 30 个字符' }]}
                >
                    <Input placeholder="请输入功能入口名称，如：首页商城" maxLength={30} showCount />
                </Form.Item>
                <Form.Item
                    label="功能入口编码"
                    name="code"
                    rules={[{ required: true, message: '请输入功能入口编码' }, { pattern: /^[a-zA-Z_][a-zA-Z0-9_]*$/, message: '建议英文/下划线，如 home_mall' }]}
                >
                    <Input placeholder="请输入编码，如：home_mall" maxLength={64} showCount />
                </Form.Item>
                <Form.Item label="排序" name="sort" rules={[{ required: true, message: '请输入排序值' }]}>
                    <InputNumber min={1} max={999} style={{ width: '100%' }} placeholder="数值越小越靠前" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default EntryFormDialog;
